import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Anchor from '../../../../../components/link/Anchor';
import { setDash, setNumberWithComma } from '../../../../../lib/common';
import { DISCOUNT_TYPE_TEXT } from '../../../../../constants/service/app/productConstants';
import './ExcelBulkEditProductDiscountSuccessModal.scss';

const ExcelBulkEditProductDiscountSuccessModal = (props) => {
  const { isOpen, data, closeModal, getProductSubCategoryList } = props;
  const { productList = [] } = data;

  return (
    <Modal
      title="상품 할인 일괄변경 성공"
      isOpen={isOpen}
      width={1250}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="excel-bulk-edit-product-discount-success-modal-wrap">
        <div className="excel-bulk-edit-product-discount-success-title">
          요청하신 {setNumberWithComma(productList.length, '개')} 상품의 할인 일괄변경이 성공적으로 업데이트되었습니다.
        </div>

        <InfoTable>
          <thead>
            <tr>
              <th>순번</th>
              <th>상품 번호</th>
              <th>상품명</th>
              <th>1차 카테고리</th>
              <th>2차 카테고리</th>
              <th>판매가(원)</th>
              <th>할인가(원)</th>
              <th>할인율(%)</th>
              <th>할인설정</th>
              <th>할인 시작일</th>
              <th>할인 종료일</th>
              <th>할인된 판매가(원)</th>
              <th>실판매가(원)</th>
            </tr>
          </thead>
          <tbody>
            {productList.map((item, index) => (
              <tr key={index}>
                <td className="tc">{index + 1}</td>
                <td className="tc">{item.productId}</td>
                <td className="tc">{item.name}</td>
                <td className="tc">{item.mainCategory}</td>
                <td className="tc">
                  {item.isSubCategoryExists ? (
                    <Anchor
                      text="카테고리 보기"
                      isUnderLine
                      color="primary"
                      onClick={() =>
                        getProductSubCategoryList({
                          productId: item.productId,
                        })
                      }
                    />
                  ) : (
                    '-'
                  )}
                </td>
                <td className="tc">{setNumberWithComma(item.originPrice)}</td>
                <td className="tc">{setNumberWithComma(item.discountAmount)}</td>
                <td className="tc">{setNumberWithComma(item.discountRate)}</td>
                <td className="tc">{setDash(DISCOUNT_TYPE_TEXT[item.discountType])}</td>
                <td className="tc">{setDash(item.discountStartDate)}</td>
                <td className="tc">{setDash(item.discountEndDate)}</td>
                <td className="tc">{setNumberWithComma(item.salesPrice)}</td>
                <td className="tc">{setNumberWithComma(item.realPrice)}</td>
              </tr>
            ))}
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default ExcelBulkEditProductDiscountSuccessModal;
